import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MISSING_REFRESH_TOKEN_ERROR } from '@fb-tool-front/shared/constants/auth.constants';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const apiRegex = /aitarget\.(com|tech)\/api\//;

    const handleNextRequest = (token: string) =>
      next.handle(
        req.clone({
          setHeaders: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            Authorization: `Bearer ${token}`
          }
        })
      );
    const isJwtUrl = req.url.match(apiRegex) && !req.url.includes('api/auth');

    const refreshTokenErrorHandler = err => {
      if (
        (err instanceof HttpErrorResponse && err.status === 401) ||
        err?.type === MISSING_REFRESH_TOKEN_ERROR
      ) {
        this.authService.logout();
        return EMPTY;
      }

      return throwError(err);
    };

    if (isJwtUrl) {
      if (!this.authService.isTokenExpired()) {
        return handleNextRequest(this.authService.getToken()).pipe(
          catchError((tokenError: any) => {
            if (tokenError instanceof HttpErrorResponse && tokenError.status === 401) {
              return this.authService.refreshToken().pipe(
                switchMap(() => handleNextRequest(this.authService.getToken())),
                catchError(refreshTokenErrorHandler)
              );
            }

            return throwError(tokenError);
          })
        );
      } else {
        return this.authService.refreshToken().pipe(
          switchMap(() => handleNextRequest(this.authService.getToken())),
          catchError(refreshTokenErrorHandler)
        );
      }
    } else {
      return next.handle(req);
    }
  }
}
